;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();export const ONE_SECOND_MS = 1000

export const FIVE_SECONDS = ONE_SECOND_MS * 5

export const FIFTEEN_SECONDS = ONE_SECOND_MS * 15
export const THIRTY_SECONDS = ONE_SECOND_MS * 30

const ONE_MINUTE_MS = ONE_SECOND_MS * 60
const FOUR_MINUTES_MS = ONE_MINUTE_MS * 4

const ONE_HOUR_MS = ONE_MINUTE_MS * 60

export const ONE_DAY_MS = ONE_HOUR_MS * 24

export const REFRESH_SESSION_STALE_TIME = FOUR_MINUTES_MS
